import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './search.routes';
import addHtml from './modal/add.html';

export class SearchController {
    $http;
    socket;
    awesomeThings = [];
    searchs = [];
    newThing = '';

    /*@ngInject*/
    constructor($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
        this.$http = $http;
        this.socket = socket;
        this.$uibModal = $uibModal;
        this.$cookies = $cookies;
        this.$cookieStore = $cookieStore;
        this.$location = $location;


        // $scope.$on('$destroy', function() {
        //   socket.unsyncUpdates('search');
        // });
    }

    $onInit() {

        if (this.$cookies.get('token')) {
            this.$http.get('/api/searchs/', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: {
                    'page': 0,
                    'size': 20
                }
            })
                .then(response => {
                    if (response.data.data) {


                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.currentPage = 1;

                        this.searchs = response.data.data;
                        this.socket.syncUpdates('search', this.searchs);
                    }

                });
        } else {
            this.$location.path('main')
        }
    }

    search() {
        if (this.$cookies.get('token')) {

            this.$http.get('/api/searchs/', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: {
                    'page': this.currentPage - 1,
                    'size': 20
                }
            })
                .then(response => {
                    if (response.data.data) {
                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.searchs = response.data.data;

                        this.socket.syncUpdates('search', this.searchs);
                    }
                });
        } else {
            this.$location.path('main')
        }
    }

    // addThing() {
    //   if(this.newThing) {
    //     this.$http.post('/api/things', {
    //       name: this.newThing
    //     });
    //     this.newThing = '';
    //   }
    // }

    deleteSearch(search, index) {
        this.$http.delete(`/api/searchs/${search.search_id}`).then(response => {
            if (response.status === 204) {
                this.searchs.splice(index, 1)
            }
        }, error => {
            console.log(error);
        });
    }
}

export default angular.module('tttApp.search', [uiRouter])
    .config(routing)
    .component('search', {
        template: require('./search.html'),
        controller: SearchController
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/search/search.component.js